import { participantClassActionType } from '../../constants/index';

export default (state = {}, action) => {
    switch (action.type) {
        case participantClassActionType.FETCH_PARTICIPANTCLASS_ALL:
            return {
                ...state,
                "participantsClassAll": action.payload
            };
        case participantClassActionType.FETCH_PARTICIPANTCLASS_SUCCESS:
            return {
                ...state,
                "participantsClassAPISuccess": action.payload
            };
        default:
            return state;
    }
};
